import React from "react";

function CheckIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11.084" height="7.716" viewBox="0 0 11.084 7.716">
        <path data-name="Path 984" d="M3.76 6.379 1.141 3.76a.668.668 0 0 0-.945 0 .668.668 0 0 0 0 .945l2.619 2.621a1.337 1.337 0 0 0 1.891 0l6.187-6.185a.668.668 0 0 0 0-.945.668.668 0 0 0-.945 0z"/>
    </svg>
  );
}

export default CheckIcon;